import React, { Fragment } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import { BillingAccessBoundary } from '../billing/BillingAccess';

// const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => (
//   <Fragment>
//     {isAuthenticated ? <Component {...rest} /> : <Navigate to="/signin" />}
//   </Fragment>
// );

const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated && isAuthenticated !== "") {
    return <Navigate to={"/signin"} />;
  }

  return <BillingAccessBoundary>{children ? children : <AppLayout />}</BillingAccessBoundary>;
};

export default ProtectedRoute;
